// Cross-tab "the state blob changed" signal. Another tab writing the blob
// invalidates this tab's in-memory canonical state so it re-reads instead of
// clobbering with stale data. BroadcastChannel never delivers to its own
// context, so a tab is never invalidated by its own writes. No-ops where the
// API is unavailable (per-tab behavior unchanged — same as today).
const CHANNEL_NAME = 'knittime-state';

type Callback = () => void;
const callbacks: Callback[] = [];
let channel: BroadcastChannel | null = null;
let installed = false;

function ensureChannel(): void {
  if (installed) return;
  installed = true;
  if (typeof BroadcastChannel === 'undefined') return;
  try {
    channel = new BroadcastChannel(CHANNEL_NAME);
    channel.onmessage = () => callbacks.forEach((cb) => cb());
  } catch {
    channel = null;
  }
}

export function postStateChanged(): void {
  ensureChannel();
  try {
    channel?.postMessage('state-changed');
  } catch {
    // channel closed / serialization issue — cross-tab signal is best-effort
  }
}

export function subscribeRemoteStateChanged(cb: Callback): () => void {
  ensureChannel();
  callbacks.push(cb);
  return () => {
    const idx = callbacks.indexOf(cb);
    if (idx >= 0) callbacks.splice(idx, 1);
  };
}

// Test-only: close and reset so each test gets a fresh channel.
export function __resetStateChannelForTest(): void {
  try {
    channel?.close();
  } catch {
    // ignore
  }
  channel = null;
  installed = false;
  callbacks.length = 0;
}
